import { gql } from '@apollo/client';

export const UPSERT_HIERARCHY = gql`
  mutation UpsertHierarchy($input: UpsertHierarchyInput!) {
    hierarchy: upsertHierarchy(input: $input) {
      id
    }
  }
`;
